var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 24.245,
    viewBox: "0 0 28 24.245",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6793",
    "data-name": "Path 6793",
    d: "M25.182,12.682a1.273,1.273,0,0,0-1.273,1.273v8.909a1.273,1.273,0,0,1-1.273,1.273H4.818a1.273,1.273,0,0,1-1.273-1.273V12.682a1.273,1.273,0,0,1,1.273-1.273H7.364a1.273,1.273,0,0,0,1.273-.865l.687-2.087a1.273,1.273,0,0,1,1.209-.865h7.013a1.273,1.273,0,0,0,0-2.545H10.469A3.818,3.818,0,0,0,6.855,7.655L6.447,8.927H4.818A3.818,3.818,0,0,0,1,12.745V22.927a3.818,3.818,0,0,0,3.818,3.818H22.636a3.818,3.818,0,0,0,3.818-3.818V14.018a1.273,1.273,0,0,0-1.273-1.336ZM13.727,11.409A5.091,5.091,0,1,0,18.818,16.5,5.091,5.091,0,0,0,13.727,11.409Zm0,7.636A2.545,2.545,0,1,1,16.273,16.5,2.545,2.545,0,0,1,13.727,19.045Zm14-14H26.455V3.773a1.273,1.273,0,1,0-2.545,0V5.045H22.636a1.273,1.273,0,0,0,0,2.545h1.273V8.864a1.273,1.273,0,1,0,2.545,0V7.591h1.273a1.273,1.273,0,1,0,0-2.545Z",
    transform: "translate(-1 -2.5)",
    fill: "#949596",
    opacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.2eecaf35c0ef3f1f6ce69d4d6363e0c3.svg";
export { ForwardRef as ReactComponent };